export default "__VITE_ASSET__BvQuOvBh__"